



















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { scrollTo } from '@/shared/utils/scroll-to'

@Component
export default class RespondecoPagination extends Vue {
  @Prop({
    default: () => false,
    type: Boolean,
  })
  public readonly hideEmpty!: boolean

  @Prop({
    default: () => false,
    type: Boolean,
  })
  public readonly loading!: boolean

  @Prop({
    type: Number,
  })
  public readonly page!: number

  @Prop({
    type: Number,
  })
  public readonly pageSize!: number

  @Prop({
    default: true,
    type: [Boolean, Element, Object],
  })
  public readonly scroll!: any

  @Prop({
    default: 0,
    type: Number,
  })
  public readonly scrollOffset!: number

  @Prop({
    default: 1,
    type: Number,
  })
  public readonly total!: number

  public activePage: number = this.page

  get pages() {
    return Math.ceil(this.total / this.pageSize)
  }

  public set(value: string | number) {
    if (value === 'previous') {
      value = this.activePage - 1
    } else if (value === 'next') {
      value = this.activePage + 1
    }

    if (typeof value === 'number' && value > 0 && value <= this.pages) {
      this.activePage = value

      this.$emit('page', this.activePage)

      if (this.scroll?.$el !== undefined) {
        // Vue reference
        scrollTo(this.scroll.$el, {
          offset: this.scrollOffset,
        })
      } else if (typeof this.scroll !== 'boolean') {
        scrollTo(this.scroll, {
          offset: this.scrollOffset,
        })
      } else if (this.scroll === true) {
        scrollTo(document.body)
      }
    }
  }

  @Watch('page')
  public onPageChanged(value: number) {
    this.activePage = value
  }
}
